"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var RewardsApi = function (_BaseApi) {
  (0, _inherits2["default"])(RewardsApi, _BaseApi);

  function RewardsApi(baseUrl) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var olyEngineApi = arguments.length > 2 ? arguments[2] : undefined;
    var searchService = arguments.length > 3 ? arguments[3] : undefined;
    (0, _classCallCheck2["default"])(this, RewardsApi);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RewardsApi).call(this, baseUrl, options, olyEngineApi));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchService", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getReward", function (_ref) {
      var rewardId = _ref.rewardId,
          clientId = _ref.clientId,
          noCache = _ref.noCache;
      return _this.api.get("/rewards/".concat(rewardId).concat(clientId ? "?clientId=".concat(clientId) : '').concat(noCache && clientId ? '&no-cache' : '')).then(function (p) {
        return p.request;
      }).then(function (res) {
        return Array.isArray(res) ? res[0] : res;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRewardRedeemedUsers", function (_ref2) {
      var rewardId = _ref2.rewardId,
          search = _ref2.search,
          limit = _ref2.limit,
          skip = _ref2.skip,
          clientId = _ref2.clientId;
      return _this.api.get("/v3/rewards/".concat(rewardId, "/redeemed-users"), {
        params: {
          search: search,
          limit: limit,
          skip: skip,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRewardsByQuery", function (_ref3) {
      var index = _ref3.index,
          query = _ref3.query,
          searchOptions = _ref3.searchOptions;
      return _this.searchService.requestIndex({
        index: index,
        query: query,
        searchOptions: searchOptions
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "redeemReward", function (_ref4) {
      var rewardId = _ref4.rewardId,
          clientId = _ref4.clientId;
      return _this.api.get("/rewards/".concat(rewardId, "/redeem/").concat(clientId ? "?clientId=".concat(clientId) : ''));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "extractReward", function (_ref5) {
      var rewardId = _ref5.rewardId,
          clientId = _ref5.clientId;
      return _this.api.get("/extract/reward/".concat(rewardId, "?clientId=").concat(clientId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createReward", function (_ref6) {
      var data = _ref6.data,
          clientId = _ref6.clientId;
      return _this.api.post("/rewards/".concat(clientId ? "?clientId=".concat(clientId) : ''), {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editReward", function (_ref7) {
      var data = _ref7.data,
          clientId = _ref7.clientId;
      return _this.api.post("/rewards/".concat(clientId ? "?clientId=".concat(clientId) : ''), {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteReward", function (_ref8) {
      var rewardId = _ref8.rewardId,
          clientId = _ref8.clientId;
      return _this.api["delete"]("/rewards/".concat(rewardId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRewardsByUsers", function (_ref9) {
      var clientId = _ref9.clientId,
          userId = _ref9.userId,
          limit = _ref9.limit,
          skip = _ref9.skip;
      return _this.api.get("/v3/rewards/users/".concat(userId), {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip
        }
      });
    });
    _this.searchService = searchService;
    return _this;
  }

  return RewardsApi;
}(_createApi.BaseApi);

var _default = RewardsApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map